import React, { Component } from 'react';

import { connect } from 'react-redux';

import { Col, Container, Nav, Row, Tab, Figure, Badge, Card } from 'react-bootstrap';

import { toggleCollapsedNav } from '../redux/action/Theme';

import DashboardMultiLineChart from './dashboard/DashboardMultiLineChart';
import DashboardPieChart from './dashboard/DashboardPieChart';

import CommonTokenExpired from './components/CommonTokenExpired';

import * as Actions from './actions/ActionCenter';

import * as charts from '../library/charts';
import DataTableDashboardCustom from './dataTables/DataTableDashboardCustom';
import DashboardVerticalBarChart from './dashboard/DashboardVerticalBarChart';

const academyIncrease = {
    labels: [
        'อาชีวศึกษา',
        'มหาวิทยาลัย',
    ],
    datasets: [
        {
            data: [100, 45],
            borderWidth: 1
        }
    ]
};

const academyChartData = {
    labels: ['2502', '2536', '2537', '2540', '2541'],
    datasets: [
        {
            label: 'อาชีวศึกษา',
            data: [309, 310, 311, 312, 313],
            borderColor: charts.getChartColorSet('1').borderColor,
            backgroundColor: charts.getChartColorSet('1').backgroundColor,
            fill: true,
            pointRadius: 3
        },
        {
            label: 'มหาวิทยาลัย',
            data: [345, 345, 345, 345, 345],
            borderColor: charts.getChartColorSet('2').borderColor,
            backgroundColor: charts.getChartColorSet('2').backgroundColor,
            fill: true,
            pointRadius: 3
        },
    ]
};

const academyEnumerate = {
    columnName: ['ปี', 'ชลบุรี', 'ระยอง', 'ฉะเชิงเทรา', 'รวม'],
    rows: [
        {
            'ปี': '2566',
            'ชลบุรี': '43',
            'ระยอง': '36',
            'ฉะเชิงเทรา': '15',
            'รวม': '80'
        },
        {
            'ปี': '2567',
            'ชลบุรี': '56',
            'ระยอง': '80',
            'ฉะเชิงเทรา': '20',
            'รวม': '90'
        },
        {
            'ปี': '2568',
            'ชลบุรี': '89',
            'ระยอง': '36',
            'ฉะเชิงเทรา': '29',
            'รวม': '100'
        },
        {
            'ปี': '2569',
            'ชลบุรี': '103',
            'ระยอง': '36',
            'ฉะเชิงเทรา': '30',
            'รวม': '110'
        },
    ]
};

const graduatedChartData = {
    labels: ['2565', '2566', '2567', '2568'],
    datasets: [
        {
            label: 'ทวิภาคี',
            data: [8600, 9200, 9900, 10700, 11400],
            borderColor: charts.getChartColorSet('1').borderColor,
            backgroundColor: charts.getChartColorSet('1').backgroundColor,
            fill: true,
            pointRadius: 3
        },
        {
            label: '100%',
            data: [7600, 8200, 8900, 9700, 10400],
            borderColor: charts.getChartColorSet('3').borderColor,
            backgroundColor: charts.getChartColorSet('3').backgroundColor,
            fill: true,
            pointRadius: 3
        },
    ]
};

const graduatedDataTable = {
    columnName: ['อุตสาหกรรม', 'ผู้สำเร็จการศึกษา', 'ทวิภาคี', '100%', 'สัดส่วน (%)'],
    rows: [
            {
                'อุตสาหกรรม': 'อิเล็กทรอนิกส์',
                'ผู้สำเร็จการศึกษา': '512',
                'ทวิภาคี': '401',
                '100%': '338',
                'สัดส่วน (%)': '78'
            },
            {
                'อุตสาหกรรม': 'ยานยนต์',
                'ผู้สำเร็จการศึกษา': '436',
                'ทวิภาคี': '352',
                '100%': '281',
                'สัดส่วน (%)': '81'
            },
            {
                'อุตสาหกรรม': 'หุ่นยนต์',
                'ผู้สำเร็จการศึกษา': '298',
                'ทวิภาคี': '244',
                '100%': '197',
                'สัดส่วน (%)': '82'
            },
            {
                'อุตสาหกรรม': 'การแปรรูปอาหาร',
                'ผู้สำเร็จการศึกษา': '624',
                'ทวิภาคี': '503',
                '100%': '421',
                'สัดส่วน (%)': '81'
            },
            {
                'อุตสาหกรรม': 'ดิจิตอล',
                'ผู้สำเร็จการศึกษา': '389',
                'ทวิภาคี': '315',
                '100%': '252',
                'สัดส่วน (%)': '81'
            },
            {
                'อุตสาหกรรม': 'อื่นๆ',
                'ผู้สำเร็จการศึกษา': '271',
                'ทวิภาคี': '198',
                '100%': '156',
                'สัดส่วน (%)': '73'
            },
            {
                'อุตสาหกรรม': 'รวม',
                'ผู้สำเร็จการศึกษา': '2530',
                'ทวิภาคี': '2013',
                '100%': '1645',
                'สัดส่วน (%)': '80'
            },
        ],
    page: 1,
    pageSize: 10,
    totalRows: 6
};

const supportEntreprenuer = {
    labels: ['อิเล็กทรอนิกส์', 'ยานยนต์', 'หุ่นยนต์', 'การแปรรูปอาหาร', 'ดิจิตอล'],
    datasets: [
        {
            label: 'ผลผลิต',
            data: [100, 75, 70, 45, 42]
        },
        {
            label: 'ความต้องการ',
            data: [45, 40, 30, 25, 22]
        }
    ]
};

const supportEntreprenuerDataTable = {
    columnName: ['อุตสาหกรรม', 'จำนวนสถานประกอบการ', 'ทวิภาคี', '100%', 'สัดส่วน (%)'],
    rows: [
        {
            'อุตสาหกรรม': 'อิเล็กทรอนิกส์',
            'จำนวนสถานประกอบการ': '52',
            'ทวิภาคี': '41',
            '100%': '33',
            'สัดส่วน (%)': '79'
        },
        {
            'อุตสาหกรรม': 'ยานยนต์',
            'จำนวนสถานประกอบการ': '38',
            'ทวิภาคี': '27',
            '100%': '21',
            'สัดส่วน (%)': '71'
        },
        {
            'อุตสาหกรรม': 'หุ่นยนต์',
            'จำนวนสถานประกอบการ': '46',
            'ทวิภาคี': '35',
            '100%': '30',
            'สัดส่วน (%)': '87'
        },
        {
            'อุตสาหกรรม': 'การแปรรูปอาหาร',
            'จำนวนสถานประกอบการ': '61',
            'ทวิภาคี': '49',
            '100%': '40',
            'สัดส่วน (%)': '80'
        },
        {
            'อุตสาหกรรม': 'ดิจิตอล',
            'จำนวนสถานประกอบการ': '44',
            'ทวิภาคี': '31',
            '100%': '26',
            'สัดส่วน (%)': '84'
        },
    ],
    page: 1,
    pageSize: 10,
    totalRows: 6
};

const getLastYearTotal = (chartData, offset = 0) => {
    return chartData.datasets.reduce((sum, ds) => {
        const dataLength = ds.data.length;
        const value = ds.data[dataLength - 1 - offset] ?? 0;
        return sum + value;
    }, 0);
};

const growthTotal = () => {
    const totalAcademy = getLastYearTotal(academyChartData, 0);
    return `${totalAcademy} แห่ง`;
};

const growthPercent = () => {
    const totalAcademy = getLastYearTotal(academyChartData, 0);
    const totalLastYear = getLastYearTotal(academyChartData, 1);

    if (totalLastYear === 0) {
        return '(0.0% จากปีก่อน)';
    }

    const percent =
        ((totalAcademy - totalLastYear) / totalLastYear) * 100;

    const sign = percent > 0 ? '+' : percent < 0 ? '-' : '';

    return `(${sign}${Math.abs(percent).toFixed(1)}% จากปีก่อน)`;
};

class DashboardMockup extends Component {

    constructor(props) {
        super(props);

        this.state = {
            Masterbase: {},
            Token: {
                Expired: false
            }
        };
        this.updateState = this.setState.bind(this);
    }

    loadMasterbase = async () => {
        let sets = [
            { key: "dashboard_eb_budget_summary_industries", filter: [] },
        ];

        await Actions.loadMasterbase(this.updateState, sets);
    }

    initialize = async () => {
        await this.loadMasterbase();
    }

    componentDidMount = async () => {
        this.props.toggleCollapsedNav(false);
        await this.initialize();
    }

    StatCard = ({ title, detail }) => {
        return (
            <Card className='text-center p-2'>
                <div className='p-3'>
                    <h5>
                        {title}
                    </h5>
                    <span>{detail}</span>
                </div>
            </Card>
        )
    }

    render = () => {

        let { Token } = this.state;

        return (
            <>
                <Container>

                    <CommonTokenExpired Token={Token} />

                    <div className="hk-pg-header pg-header-with-tab pt-7">
                        <div className="d-flex">
                            <div className="d-flex flex-wrap justify-content-between flex-1">
                                <div className="mb-lg-0 mb-2 me-8">
                                    <Figure>
                                        <h4>ยินดีต้อนรับสู่ EEC มีงานทำ</h4>
                                        <figcaption className="blockquote-footer mt-2">EECmeengantam.eeco.or.th - Back Office System</figcaption>
                                    </Figure>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="hk-pg-body">
                        <Row className='my-5'>
                            <Col>
                                <Figure>
                                    <h4>ข้อมูลสถานศึกษา</h4>
                                </Figure>
                            </Col>
                        </Row>
                        <Row>

                            <Col xxl={4} lg={6} md={6} className="mb-md-4">
                                <DashboardPieChart
                                    title='ภาพรวม'
                                    icon='fa-classic fa-regular fa-badge-dollar fa-fw'
                                    chartData={academyIncrease}
                                    legend={true}
                                    position='bottom'
                                    align='start'
                                    bg="info"
                                    customText={[growthTotal(), growthPercent()]}
                                    cardWrap={false}
                                />
                            </Col>

                            <Col xxl={8} lg={6} md={6} className="mb-md-4">
                                <DashboardMultiLineChart
                                    title="จำนวนสถานศึกษาในพื้นที่ EEC (แห่ง)"
                                    icon="fa-solid fa-chart-line"
                                    bg="primary"
                                    chartData={academyChartData}
                                    cardWrap={false}
                                    suggestedMaxY={20}
                                    suggestedMinY={20}
                                />
                            </Col>

                        </Row>

                        <DataTableDashboardCustom
                            title=''
                            icon='fa-classic fa-regular fa-badge-dollar fa-fw'
                            data={academyEnumerate}
                            columnName={academyEnumerate.columnName}
                            bg="primary"
                            cardWrap={false}
                            colorOpacityWithValue
                        />

                        <Row className='my-5'>
                            <Col>
                                <Figure>
                                    <h4>ข้อมูลนักศึกษาที่สำเร็จการศึกษาในพื้นที่ EEC</h4>
                                </Figure>
                            </Col>
                        </Row>

                        <Row>

                            <Col xxl={4} lg={6} md={6} className="mb-md-4">
                                <this.StatCard title={'นักศึกษาสำเร็จการศึกษา'} detail={'18,470 คน (+10% จากปีก่อน)'}/>
                                <this.StatCard title={'ทวิภาคี'} detail={'10,400 คน'}/>
                                <this.StatCard title={'100%'} detail={'8,070 คน'}/>
                            </Col>

                            <Col xxl={8} lg={6} md={6} className="mb-md-4">
                                <DashboardMultiLineChart
                                    title="จำนวนสถานศึกษาในพื้นที่ EEC (แห่ง)"
                                    icon="fa-solid fa-chart-line"
                                    bg="primary"
                                    chartData={graduatedChartData}
                                    cardWrap={false}
                                />
                            </Col>

                        </Row>

                        <DataTableDashboardCustom
                            title=''
                            icon='fa-classic fa-regular fa-badge-dollar fa-fw'
                            data={graduatedDataTable}
                            columnName={graduatedDataTable.columnName}
                            bg="primary"
                            cardWrap={false}
                        />

                        <Row className='my-5'>
                            <Col>
                                <Figure>
                                    <h4>ข้อมูลสถานประกอบการที่สนับสนุน Type A</h4>
                                </Figure>
                            </Col>
                        </Row>

                        <Row>

                            <Col xxl={4} lg={6} md={6} className="mb-md-4">
                                <this.StatCard title={'สถานประกอบการที่สนับสนุน'} detail={'3,750 แห่ง (+10% จากปีก่อน)'}/>
                                <this.StatCard title={'ทวิภาคี'} detail={'2,200 แห่ง'}/>
                                <this.StatCard title={'100%'} detail={'1,550 แห่ง'}/>
                            </Col>

                            <Col xxl={8} lg={6} md={6} className="mb-md-4">
                                <DashboardVerticalBarChart
                                    title="จำนวนสถาบันการศึกษา"
                                    icon="fa-solid fa-chart-column"
                                    bg="primary"
                                    data={supportEntreprenuer}
                                    cardWrap={false}
                                    stacked={true}
                                />
                            </Col>

                        </Row>

                        <DataTableDashboardCustom
                            title=''
                            icon='fa-classic fa-regular fa-badge-dollar fa-fw'
                            data={supportEntreprenuerDataTable}
                            columnName={supportEntreprenuerDataTable.columnName}
                            bg="primary"
                            cardWrap={false}
                        />

                        <Row className='my-5'>
                            <Col>
                                <Figure>
                                    <h4>ข้อมูลผลผลิตกำลังคนและความต้องการกำลังคน</h4>
                                </Figure>
                            </Col>
                        </Row>

                        <Row>
                            <Col xxl={12} lg={12} md={12} className="mb-md-4">
                                <DashboardVerticalBarChart
                                    title="จำนวนสถาบันการศึกษา"
                                    icon="fa-solid fa-chart-column"
                                    bg="primary"
                                    data={supportEntreprenuer}
                                    cardWrap={false}
                                />
                            </Col>
                        </Row>
                    </div>

                </Container>
            </>
        )
    }
}

const mapStateToProps = ({ theme }) => {
    const { navCollapsed } = theme;
    return { navCollapsed };
}

export default connect(mapStateToProps, { toggleCollapsedNav })(DashboardMockup);